module.exports = __webpack_public_path__ + "media/photo/telecom_man-be0b97e5.png";